import { ClientTimePicker } from "../inputs/ClientTimePicker";
import { getCurrentTime, getFormatTime } from "../../lib/utils";
import { getTimeFormat } from "../../lib/fields/TimeField";
export const TimePreview = ({
  update,
  guid,
  default: defaultValue,
  style,
  value = defaultValue,
  required,
  read_only,
  label,
  errors,
  onBlur
}) => {
  const timeFormat = getTimeFormat(style);
  const getDefaultTime = () => {
    if (value === 'BLANK') {
      return '';
    }
    if (value) {
      return value;
    }
    return getCurrentTime(timeFormat);
  };
  const updateTime = (time = value) => {
    if (!blur) {
      setBlur(true);
    }
    const newTime = getFormatTime({
      time: time,
      timeformat: timeFormat
    });
    update(newTime);
  };
  const timePickerProps = {
    guid: guid,
    className: `input-fields__input`,
    format: timeFormat,
    style,
    update: updateTime,
    defaultDate: getDefaultTime(),
    required,
    readOnly: read_only,
    label,
    error: errors,
    errorText: errors,
    onBlur
  };
  return <div className={`foundry--input-fields user-form--input ${errors && 'foundry--field-error'}`}>
      <ClientTimePicker {...timePickerProps} />
    </div>;
};